var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0009 7.87476C17.5517 8.02589 17.9854 8.4712 18.1326 9.03671C18.4001 10.0616 18.4001 12.2001 18.4001 12.2001C18.4001 12.2001 18.4001 14.3385 18.1326 15.3635C17.9854 15.929 17.5517 16.3743 17.0009 16.5255C16.0028 16.8001 12.0001 16.8001 12.0001 16.8001C12.0001 16.8001 7.99741 16.8001 6.99923 16.5255C6.44846 16.3743 6.01472 15.929 5.86752 15.3635C5.6001 14.3385 5.6001 12.2001 5.6001 12.2001C5.6001 12.2001 5.6001 10.0616 5.86752 9.03671C6.01472 8.4712 6.44846 8.02589 6.99923 7.87476C7.99741 7.6001 12.0001 7.6001 12.0001 7.6001C12.0001 7.6001 16.0028 7.6001 17.0009 7.87476ZM10.8001 10.4001V14.4001L14.0001 12.4001L10.8001 10.4001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.b35134798e3087e4be2c1298db52e7c4.svg";
export { ForwardRef as ReactComponent };